exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".printerWrapper {\n  position: fixed;\n  left:0;top:0;right:0;bottom:0;\n  background-color: rgba(255, 255, 255, 0.5);\n  z-index:1111;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/printer.component.css
// module id = 439
// module chunks = 0